// Cart Notification System for Final Sale & Vehicle Info
(function() {
  'use strict';
  
  console.log("Cart notification system initializing...");
  
  // Wait for DOM and jQuery to be ready
  function init() {
    if (typeof jQuery === 'undefined') {
      console.error("jQuery not loaded - cart notifications disabled");
      return;
    }
    
    jQuery(document).ready(function($){
      console.log("Cart notification system loaded with jQuery");
      
      // Find cart container with multiple possible selectors
      var cartSelectors = [
        '#main-cart-items',
        '.cart-items',
        '.cart__items',
        '[data-cart-items]',
        'cart-items',
        '.js-contents'
      ];
      
      var cartContainer = null;
      for(var i = 0; i < cartSelectors.length; i++) {
        var el = $(cartSelectors[i]);
        if(el.length > 0) {
          cartContainer = el;
          console.log("Found cart container:", cartSelectors[i]);
          break;
        }
      }
      
      if(!cartContainer) {
        console.warn("Cart container not found - are you on the cart page?");
      }
      
      // Initialize notification system
      initCartNotifications();
      
      function initCartNotifications() {
        console.log("Checking cart for notifications...");
        checkAndDisplayNotifications();
        
        // Re-check when cart changes
        if(cartContainer) {
          var observer = new MutationObserver(function(){
            console.log("Cart changed, re-checking notifications...");
            checkAndDisplayNotifications();
          });
          
          observer.observe(cartContainer[0], { childList: true, subtree: true });
        }
        
        // Also check periodically as fallback
        setInterval(checkAndDisplayNotifications, 3000);
      }

      function checkAndDisplayNotifications() {
        $.getJSON('/cart.js', function(cart){
          console.log("Cart data:", cart);
          console.log("Cart items:", cart.items);
          
          // Check if vehicle info is provided
          var hasVehicleInfo = checkVehicleInfo();
          console.log("Has vehicle info:", hasVehicleInfo);
          
          // Check if notes contain YMM info
          var hasYMMInNotes = checkNotesForYMM();
          console.log("Has YMM in notes:", hasYMMInNotes);
          
          // Count items by type
          var singleTireCount = 0;
          var singleWheelCount = 0;
          var hasWheels = false;
          var hasAccessories = false;
          var totalItems = 0;
          
          cart.items.forEach(function(item){
            var productType = item.product_type ? item.product_type.toLowerCase() : "";
            console.log("Item:", item.title, "Type:", productType, "Qty:", item.quantity);
            
            if(productType === 'tires' || productType === 'tire') {
              singleTireCount += item.quantity;
            }
            else if(productType === 'wheels' || productType === 'wheel') {
              singleWheelCount += item.quantity;
              hasWheels = true;
            }
            else if(productType && productType !== '' && productType !== 'tires' && productType !== 'tire') {
              // Any other product type is considered an accessory
              hasAccessories = true;
            }
            
            totalItems += item.quantity;
          });
          
          console.log("Tire count:", singleTireCount, "Wheel count:", singleWheelCount, "Has accessories:", hasAccessories, "Total:", totalItems);
          
          // Determine which notifications to show
          var notifications = [];
          
          // 1. Single tire final sale
          if(singleTireCount === 1) {
            console.log("Adding single tire notification");
            notifications.push({
              type: 'warning',
              title: 'Single Tire Final Sale Notice',
              message: 'Please note: Single tire purchases are final sale and cannot be returned or exchanged.'
            });
          }
          
          // 2. Single wheel final sale (only if no vehicle info)
          if(singleWheelCount === 1 && !hasVehicleInfo && !hasYMMInNotes) {
            console.log("Adding single wheel notification");
            notifications.push({
              type: 'warning',
              title: 'Single Wheel Final Sale Notice',
              message: 'Single wheels are final sale if vehicle information is not provided. Please select your vehicle above or add your Year/Make/Model in the notes section to ensure proper fitment and return eligibility.'
            });
          }
          
          // 3. Request vehicle info ONLY for orders with wheels or accessories (not tire-only orders)
          if(totalItems > 0 && !hasVehicleInfo && !hasYMMInNotes && (hasWheels || hasAccessories)) {
            // Only show if we're not already showing single wheel message
            if(singleWheelCount !== 1) {
              console.log("Adding vehicle info request notification");
              notifications.push({
                type: 'info',
                title: 'Vehicle Information Needed',
                message: 'To prevent shipping delays and ensure proper fitment, please enter your Year/Make/Model in the Fitment Note section.'
              });
            }
          }
          
          console.log("Total notifications to display:", notifications.length);
          
          // Display notifications
          if(notifications.length > 0) {
            displayNotifications(notifications);
          } else {
            removeNotifications();
          }
        }).fail(function(error){
          console.error("Error fetching cart:", error);
        });
      }

      function checkVehicleInfo() {
        // Check if vehicle widget has "selected" class
        var vehicleWidget = $('#cm_HeaderVehicleWidget_cart .cm_vehicle-widget_title');
        var hasSelected = vehicleWidget.hasClass('selected');
        console.log("Vehicle widget check:", vehicleWidget.length, "Has selected class:", hasSelected);
        return hasSelected;
      }

      function checkNotesForYMM() {
        // Check if the notes field contains year/make/model info
        var notesField = $('textarea[name="note"], input[name="note"], #cart-note, [name*="note"]');
        console.log("Notes field found:", notesField.length);
        if(notesField.length) {
          var notesText = notesField.val() || '';
          console.log("Notes text:", notesText);
          // Simple check for potential YMM info (year pattern + some text)
          var hasYear = /\b(19|20)\d{2}\b/.test(notesText);
          var hasContent = notesText.trim().length > 10;
          return hasYear && hasContent;
        }
        return false;
      }

      function displayNotifications(notifications) {
        console.log("Displaying", notifications.length, "notifications");
        
        // Remove existing notification if present
        removeNotifications();
        
        // Build notification HTML
        var notificationHTML = '<div id="cart-notification-banner" style="margin: 20px 0;">';
        
        notifications.forEach(function(notif){
          var bgColor = notif.type === 'warning' ? '#fff3cd' : '#d1ecf1';
          var borderColor = notif.type === 'warning' ? '#ffc107' : '#17a2b8';
          var iconColor = notif.type === 'warning' ? '#856404' : '#0c5460';
          var icon = notif.type === 'warning' ? '⚠️' : 'ℹ️';
          
          notificationHTML += `
            <div class="cart-notification-item" style="
              background-color: ${bgColor};
              border: 2px solid ${borderColor};
              border-radius: 8px;
              padding: 15px 20px;
              margin-bottom: 15px;
              display: flex;
              align-items: start;
              box-shadow: 0 2px 4px rgba(0,0,0,0.1);
            ">
              <div style="font-size: 24px; margin-right: 15px; flex-shrink: 0;">${icon}</div>
              <div style="flex: 1;">
                <strong style="display: block; margin-bottom: 5px; color: ${iconColor}; font-size: 16px;">
                  ${notif.title}
                </strong>
                <p style="margin: 0; color: ${iconColor}; font-size: 14px; line-height: 1.5;">
                  ${notif.message}
                </p>
              </div>
            </div>
          `;
        });
        
        notificationHTML += '</div>';
        
        // Try multiple insertion points
        var inserted = false;
        var insertTargets = [
          $('#main-cart-items'),
          $('.cart-items').first().parent(),
          $('.cart__items').first().parent(),
          $('cart-items'),
          $('.page-width').first()
        ];
        
        for(var i = 0; i < insertTargets.length; i++) {
          if(insertTargets[i].length > 0) {
            console.log("Inserting notification at target", i);
            insertTargets[i].prepend(notificationHTML);
            inserted = true;
            break;
          }
        }
        
        if(!inserted) {
          console.warn("Could not find suitable insertion point for notifications");
        }
      }

      function removeNotifications() {
        $('#cart-notification-banner').remove();
      }

      // Update placeholder text for notes field
      updateNotesPlaceholder();
      
      function updateNotesPlaceholder() {
        var notesField = $('textarea[name="note"], #cart-note, [name*="note"]');
        if(notesField.length && notesField.attr('placeholder')) {
          var currentPlaceholder = notesField.attr('placeholder');
          if(!currentPlaceholder.toLowerCase().includes('year') && 
             !currentPlaceholder.toLowerCase().includes('make') && 
             !currentPlaceholder.toLowerCase().includes('model')) {
            notesField.attr('placeholder', currentPlaceholder + ' (Include Year/Make/Model if not selected above)');
          }
        }
      }
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();